import React, { FunctionComponent } from 'react'
import { useQueries } from '../../../../../utils/hooks/useQueries'
import ProjectLineMobile from './ProjectLineMobile'
import ProjectLineDesktop from './ProjectLineDesktop'
import { ProjectLineProps } from './props'

const ProjectLine: FunctionComponent<ProjectLineProps> = props => {
    const {isMobile} = useQueries()
    return isMobile ? <ProjectLineMobile {...props}/> : <ProjectLineDesktop {...props}/>
}

export default ProjectLine